import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/global-error.tsx");
